import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import { ValidationProvider, extend } from 'vee-validate'

Vue.component('validation-provider', ValidationProvider)
